import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import environmentConfig from "../environmentConfig";
import { RootState } from "./store";

const { apiBaseUrl } = environmentConfig;

export function prepareHeaders(headers: Headers, { getState }: { getState(): unknown }): Headers {
  const { token } = (getState() as RootState).auth;

  if (!token)
    throw new Error("Empty 'token' found in state.");

  headers.set("authorization", `Bearer ${token}`);

  return headers;
}

export function apiBaseQuery(apiPath?: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  return async (args, store, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
      baseUrl: new URL(apiPath ?? "", apiBaseUrl).href,
      prepareHeaders,
    });

    return rawBaseQuery(args, store, extraOptions);
  };
}

export const post = <T>(url: string, body: NonNullable<T>): FetchArgs => ({
  url,
  method: "POST",
  body,
});

export const put = <T>(url: string, body: NonNullable<T>): FetchArgs => ({
  url,
  method: "PUT",
  body,
});
